export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-[1000px] mx-auto">
          <div className="bg-background-950 rounded-2xl overflow-hidden">
            <div className="flex flex-col lg:flex-row items-center">
              <div className="flex-1 p-8 md:p-12 text-center lg:text-left">
                <span className="inline-block text-xs font-medium text-primary-400 bg-primary-900/40 px-3 py-1 rounded-full mb-4">
                  随时追剧
                </span>
                <h2 className="text-xl md:text-2xl lg:text-3xl font-bold font-heading text-background-50 mb-3">
                  移动端访问
                </h2>
                <p className="text-sm text-background-300 leading-relaxed mb-6 max-w-[420px] mx-auto lg:mx-0">
                  天天影院已全面适配手机和平板浏览器。无需下载 App，打开浏览器访问即可畅享最新电视剧全集、国产剧全集在线、韩剧全集免费、美剧全集播放与日剧全集资源。
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                  <a
                    href="#hero"
                    className="w-full sm:w-auto px-6 py-2.5 bg-primary-500 text-background-950 font-medium text-sm rounded-lg hover:bg-primary-400 transition-colors whitespace-nowrap text-center"
                  >
                    <i className="ri-smartphone-line mr-2"></i>
                    立即访问
                  </a>
                  <span className="text-xs text-background-500">或直接在手机浏览器打开本页</span>
                </div>
              </div>
              <div className="w-full lg:w-[340px] flex-shrink-0 p-6 lg:p-0">
                <div className="relative mx-auto w-[200px] h-[400px] bg-background-800 rounded-3xl border-4 border-background-700 overflow-hidden">
                  <div className="absolute top-0 left-1/2 -translate-x-1/2 w-20 h-5 bg-background-700 rounded-b-xl"></div>
                  <div className="p-3 pt-8 h-full flex flex-col gap-2">
                    <div className="h-3 bg-primary-500/60 rounded w-3/4"></div>
                    <div className="h-24 bg-background-700 rounded-lg"></div>
                    <div className="h-2 bg-background-600 rounded w-1/2"></div>
                    <div className="h-24 bg-background-700 rounded-lg mt-1"></div>
                    <div className="h-2 bg-background-600 rounded w-2/3"></div>
                    <div className="h-24 bg-background-700 rounded-lg mt-1"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}